import { FilterSchema } from '../../../molecules/FilterBuilder/types';

export const settlementFilterSchema: FilterSchema[] = [
    // ─── Campos Principais (visíveis) ─────────────────────────────────────────
    { key: 'contract_number', label: 'Nº Contrato', type: 'text', operators: ['eq', 'contains'], defaultOperator: 'contains', visible: true },
    { key: 'status', label: 'Status', type: 'enum', operators: ['in', 'not_in'], defaultOperator: 'in', visible: true, options: [
        { value: 'OPEN', label: 'Em aberto' },
        { value: 'PAID', label: 'Pago' },
        { value: 'PARTIALLY_PAID', label: 'Parcial' },
        { value: 'SUPERSEDED', label: 'Renegociado' },
        { value: 'CANCELLED', label: 'Cancelado' },
        { value: 'PAID_WITH_LOSS', label: 'Pago c/ perda' },
    ]},
    { key: 'due_date', label: 'Vencimento', type: 'date', operators: ['before', 'after', 'between_dates'], defaultOperator: 'between_dates', visible: true },
    { key: 'contract_modality', label: 'Modalidade', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: true, options: [
        { value: 'LOAN', label: 'Empréstimo (LOAN)' },
        { value: 'CESSION', label: 'Cessão (CESSION)' },
    ]},

    // ─── Campos Ocultos (aparecem via "+ Filtro") ─────────────────────────────
    { key: 'amount', label: 'Valor', type: 'number', operators: ['eq', 'gt', 'lt', 'gte', 'lte', 'between'], defaultOperator: 'between', visible: false },
    { key: 'paid_amount', label: 'Valor Pago', type: 'number', operators: ['eq', 'gt', 'lt', 'gte', 'lte'], defaultOperator: 'gt', visible: false },
    { key: 'payer_name', label: 'Pagador', type: 'text', operators: ['contains', 'eq'], defaultOperator: 'contains', visible: false },
    { key: 'negotiation_type', label: 'Tipo Negociação', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'ORIGINAL', label: 'Original' },
        { value: 'RENEGOTIATION', label: 'Renegociação' },
        { value: 'AGREEMENT', label: 'Acordo' },
        { value: 'DEBT_CONFESSION', label: 'Confissão de Dívida' },
        { value: 'COLLATERAL', label: 'Garantia' },
    ]},
    { key: 'payment_type', label: 'Tipo Pagamento', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'FINANCIAL', label: 'Financeiro' },
        { value: 'DEBT_CONFESSION', label: 'Confissão de Dívida' },
        { value: 'ASSET_DATION', label: 'Dação de Bens' },
    ]},
    { key: 'payment_method', label: 'Meio Pagamento', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'PIX', label: 'PIX' },
        { value: 'TED', label: 'TED' },
        { value: 'BOLETO', label: 'Boleto' },
    ]},
    { key: 'pending_guarantor_refund', label: 'Aval a Devolver', type: 'boolean', operators: ['is_true', 'is_false'], defaultOperator: 'is_true', visible: false },
    { key: 'installment_number', label: 'Nº Parcela', type: 'number', operators: ['eq', 'gt', 'lt'], defaultOperator: 'eq', visible: false },
    { key: 'amendment_number', label: 'Nº Aditamento', type: 'number', operators: ['eq', 'gt'], defaultOperator: 'eq', visible: false },
    { key: 'business_reference', label: 'Referência', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'INSTALLMENT', label: 'Parcela' },
        { value: 'RECEIVABLE', label: 'Recebível' },
    ]},

    // ─── Lookup (busca avançada em contratos) ─────────────────────────────────
    { key: 'credit_operation_id', label: 'Contrato (avançado)', type: 'lookup', operators: ['in_lookup'], defaultOperator: 'in_lookup', visible: false, lookupConfig: {
        endpoint: '/contracts/receivables_assignment/list',
        searchField: 'search',
        displayField: 'operation_number',
        valueField: 'credit_operation_id',
    }},
];

// ─── Tela de Operações de Crédito (GET /settlement/operations) ───────────────
export const operationsFilterSchema: FilterSchema[] = [
    { key: 'contract_number', label: 'Nº Contrato', type: 'text', operators: ['eq', 'contains'], defaultOperator: 'contains', visible: true },
    { key: 'contract_modality', label: 'Modalidade', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: true, options: [
        { value: 'LOAN', label: 'Empréstimo (LOAN)' },
        { value: 'COMMON_CPRF', label: 'CPRF' },
        { value: 'CESSION_WITHOUT_RETURN', label: 'Cessão sem regresso' },
        { value: 'CESSION_WITH_RETURN', label: 'Cessão com regresso' },
    ]},
    { key: 'business_reference', label: 'Referência', type: 'enum', operators: ['in'], defaultOperator: 'in', visible: false, options: [
        { value: 'INSTALLMENT', label: 'Parcela' },
        { value: 'RECEIVABLE', label: 'Recebível' },
    ]},
    { key: 'credit_operation_id', label: 'Operação (id)', type: 'text', operators: ['eq'], defaultOperator: 'eq', visible: false },
];

// Serialização mora no molecule (mesma convenção filter[campo][operador] em todas as APIs).
export { serializeFilters } from '../../../molecules/FilterBuilder/serialize';
